import { Dialog } from 'primereact/dialog';
import { FC, Suspense, useEffect, useState } from 'react';
import WeeklyHistoryChart from './WeeklyHistoryChart';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { DashboardGoalMetByWeekQuery } from '../../../graphQLOperations/__generated__/DashboardGoalMetByWeekQuery.graphql';
import { getGoalMetWeekly } from '../../../graphQLOperations/Dashboard';
import { ThreeDotLoader } from '../../Fallback/ThreeDotsLoader';
import { stringByDateString } from '../../../businessLogicService/dateHandlerForTeacherDashboard';

interface Props {
  visible: boolean;
  setVisible: (v: boolean) => void;
  queryReference: PreloadedQuery<DashboardGoalMetByWeekQuery> | unknown;
}

export interface BarChartData {
  label: string;
  passed: number;
  notPassed: number;
}

const WeeklyHistoryDialog: FC<Props> = ({ visible, setVisible, queryReference }) => {
  const [dataChart, setDataChart] = useState<BarChartData[]>([]);
  const queryData = usePreloadedQuery<DashboardGoalMetByWeekQuery>(
    getGoalMetWeekly,
    queryReference as PreloadedQuery<DashboardGoalMetByWeekQuery>,
  );

  useEffect(() => {
    const parsedDataChart: BarChartData[] = [];
    queryData.studentSkillGoalsReportByWeek.forEach(el => {
      parsedDataChart.push({
        label: stringByDateString(el.dateRange.fromDate) + ' - ' + stringByDateString(el.dateRange.toDate),
        passed: el.percentageStudentsPassedGoal,
        notPassed: 100 - el.percentageStudentsPassedGoal,
      });
    });
    setDataChart([...parsedDataChart].reverse());
  }, [queryData]);

  return (
    <Dialog
      header="Weekly Goal History"
      visible={visible}
      onHide={() => {
        if (!visible) return;
        setVisible(false);
      }}
      style={{ width: '40vw', height: '100vh' }}
      breakpoints={{ '960px': '75vw', '641px': '100vw' }}
    >
      <Suspense fallback={<ThreeDotLoader />}>
        <WeeklyHistoryChart dataChart={dataChart} />
      </Suspense>
    </Dialog>
  );
};

export default WeeklyHistoryDialog;
